import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlayCircle } from "@fortawesome/free-regular-svg-icons";
import MediaModal from "./MediaModal";

class Media extends React.Component {

    constructor (props) {
        super(props);

        this.state = {
            'mediaModal': false,
            'mediaID': 1,
            'mediaURL': null,
            'embededPlayer': false,
            'embededPlayerSource': '',
        }

        // binding
        this.handleClose = this.handleClose.bind(this); 
        this.handleOpenMediaModal = this.handleOpenMediaModal.bind(this); 
    }

    
    handleClose() {
        this.setState({
            mediaModal: false
        });
    }

    handleOpenMediaModal(target) {

        // add GTM custom event
        if (window['google_tag_manager']) {
            const event_name = 'OpenHomepageVideoModal';
            console.log('GTM event: ' + event_name)

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: event_name,
                eventTimeout: 2000,
                video_id: target,
                pageUrl: window.location,
                pageTitle : window.title,
            });
        }

        // Channel 12
        let url = "https://www.youtube.com/embed/3l4_FuUdOYk?rel=0&autoplay=1";
        url = "https://player.vimeo.com/video/720437102?h=853c73329e&amp;badge=0&amp;autoplay=1&amp;title=0&amp;byline=0&amp;player_id=0&amp;app_id=58479"
        url = "https://www.youtube.com/embed/3l4_FuUdOYk?si=ijUFYoASFRYVce5N&rel=0&autoplay=1";
        
        //let videoID = "3l4_FuUdOYk";

        // Channel 13
        if (target==13) {
            //url = "https://www.youtube.com/embed/xO5tLraUsw8?rel=0&autoplay=1"
            url = "https://player.vimeo.com/video/720441281?h=50702b3b41&amp;badge=0&amp;autoplay=1&amp;title=0&amp;byline=0&amp;player_id=0&amp;app_id=58479"
            url = "https://www.youtube.com/embed/xO5tLraUsw8?si=dpCLvomvBffDvEbz&rel=0&autoplay=1&t=4s&start=4";
            //videoID = "xO5tLraUsw8";
        }

        // Channel 14
        if (target==14) {
            //url = "https://www.youtube.com/embed/xO5tLraUsw8?rel=0&autoplay=1"
            url = "https://player.vimeo.com/video/749753217?h=e0b83deb48&amp;badge=0&amp;autoplay=1&amp;title=0&amp;byline=0&amp;player_id=0&amp;app_id=58479"
            url = "https://www.youtube.com/embed/JB8YeeNR-Sc?si=2cZCrrAWReHmCWsF&rel=0&autoplay=1";
            //videoID = ""
            //videoID = "xO5tLraUsw8";
        }
        

        /*if (window.screen.width <= 1000) {
            this.setState({
                mediaModal: false,
                mediaID: target,
                mediaURL: url,
                embededPlayer: true,
                embededPlayerSource: url,
                playerID: target          
            });
    
            //window.open('intent://'+videoID+'/#Intent;scheme=vnd.youtube;package=com.google.android.youtube;S.browser_fallback_url=market://details?id=com.google.android.youtube;end;')
            return;
        }*/

        this.setState({
            mediaModal: true,
            mediaID: target,
            mediaURL: url
        });
    }

    render() {
        if (!this.props.hidden)
            return(
            <>
                <MediaModal
                    openMediaModal={this.state.mediaModal}
                    mediaID={this.state.mediaID}
                    mediaURL={this.state.mediaURL}
                    onClose={this.handleClose}
                />
                <div className="media-block">
                    <div className="wrapper">


                        

                        <div className="item first" onClick={e=>this.handleOpenMediaModal(12)}>
                            <div className={'item1 ' + (this.state.embededPlayer && this.state.mediaID==1?'hidden':'')}>
                                <FontAwesomeIcon icon={faPlayCircle} className="icon" />
                            </div>
                            <h3>תוכנית חסכון (ערוץ 12)</h3>
                            {/*<div className={'iframe1 ' + (this.state.embededPlayer && this.state.mediaID==1?'':'hidden')}>
                                <iframe sandbox="allow-scripts" src={this.state.embededPlayer && this.state.mediaID==1?this.state.embededPlayerSource:''} 
                                    allowFullScreen frameBorder="0" width="100%" height="150"
                                    allow="autoplay; fullscreen; picture-in-picture"  
                                    style={{width:'100%',margin:0, padding:0}} ></iframe>
                            </div>*/}
                        </div>


                        <div className="item second" onClick={e=>this.handleOpenMediaModal(14)}>
                            <div className={'item3 ' + (this.state.embededPlayer && this.state.mediaID==3?'hidden':'')}>
                                <FontAwesomeIcon icon={faPlayCircle} className="icon"  />
                            </div>
                            <h3>ישראל הבוקר (ערוץ 14)</h3>
                            {/*<div className={'iframe3 ' + (this.state.embededPlayer && this.state.mediaID==3?'':'hidden')}>
                                <iframe sandbox="allow-scripts" src={this.state.embededPlayer && this.state.mediaID==3?this.state.embededPlayerSource:''} 
                                    allowFullScreen frameBorder="0" width="100%" height="150"
                                    allow="autoplay; fullscreen; picture-in-picture"  
                                    style={{width:'100%',margin:0, padding:0}} ></iframe>
                            </div>*/}
                        </div>

                        <div className="item third" onClick={e=>this.handleOpenMediaModal(13)}>
                            <div className={'item2 ' + (this.state.embededPlayer && this.state.mediaID==2?'hidden':'')}>
                                <FontAwesomeIcon icon={faPlayCircle} className="icon"  />
                            </div>
                            <h3>תוכנית הבוקר (ערוץ 13)</h3>
                            {/*<div className={'iframe2 ' + (this.state.embededPlayer && this.state.mediaID==2?'':'hidden')}>
                                <iframe sandbox="allow-scripts" src={this.state.embededPlayer && this.state.mediaID==2?this.state.embededPlayerSource:''} 
                                    allowFullScreen frameBorder="0" width="100%" height="150"
                                    allow="autoplay; fullscreen; picture-in-picture"  
                                    style={{width:'100%',margin:0, padding:0}} ></iframe>
                            </div>*/}
                        </div>


                        
                    </div>
                </div>
            </>
            ) 
            else
                return (<></>);
    }
}

export default Media